import React, { useEffect } from "react";
import styles from "./ReviewImageModal.module.css";
import { reactIcons } from "../../../icons/reactIcons";

interface ReviewImageModalProps {
  open: boolean;
  images: string[];
  currentIndex: number;
  onClose: () => void;
  onNext: () => void;
  onPrev: () => void;
}

const ReviewImageModal: React.FC<ReviewImageModalProps> = ({
  open,
  images,
  currentIndex,
  onClose,
  onNext,
  onPrev,
}) => {
  useEffect(() => {
    if (open) {
      document.body.classList.add("reviewImage-modal-open");
    } else {
      document.body.classList.remove("reviewImage-modal-open");
    }

    return () => document.body.classList.remove("reviewImage-modal-open");
  }, [open]);

  if (!open) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <button className={styles.closeButton} onClick={onClose}>
          <reactIcons.RxCrossIcon />
        </button>

        {currentIndex > 0 && (
          <button className={styles.leftArrow} onClick={onPrev}>
            <reactIcons.LeftArrowIcon />
          </button>
        )}

        <img
          src={images[currentIndex]}
          alt="preview"
          className={styles.mainImage}
        />

        {currentIndex < images.length - 1 && (
          <button className={styles.rightArrow} onClick={onNext}>
            <reactIcons.RightArrowIcon />
          </button>
        )}

        <div className={styles.counter}>
          {currentIndex + 1} / {images.length}
        </div>
      </div>
    </div>
  );
};

export default ReviewImageModal;
